function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsAuthority = function SvgSettingsAuthority(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.88,33.3V34H17.13v-.7a.41.41,0,0,1,.42-.42h.7v-16a.85.85,0,0,1,.84-.84H30.91a.85.85,0,0,1,.84.84v16h.7A.42.42,0,0,1,32.88,33.3ZM21.63,20.08a.42.42,0,0,0,.42.42h1.4a.42.42,0,0,0,.43-.42V18.67a.42.42,0,0,0-.43-.42h-1.4a.42.42,0,0,0-.42.42Zm0,3.37a.42.42,0,0,0,.42.43h1.4a.43.43,0,0,0,.43-.43v-1.4a.43.43,0,0,0-.43-.43h-1.4a.42.42,0,0,0-.42.43Zm2.25,3.38V25.42a.42.42,0,0,0-.43-.42h-1.4a.42.42,0,0,0-.42.42v1.41a.42.42,0,0,0,.42.42h1.4A.42.42,0,0,0,23.88,26.83Zm2.25,3.09a.42.42,0,0,0-.43-.42H24.3a.42.42,0,0,0-.42.42v3h2.25Zm2.25-11.25a.42.42,0,0,0-.43-.42h-1.4a.42.42,0,0,0-.42.42v1.41a.42.42,0,0,0,.42.42H28a.42.42,0,0,0,.43-.42Zm0,3.38a.43.43,0,0,0-.43-.43h-1.4a.42.42,0,0,0-.42.43v1.4a.42.42,0,0,0,.42.43H28a.43.43,0,0,0,.43-.43Zm0,3.37A.42.42,0,0,0,28,25h-1.4a.42.42,0,0,0-.42.42v1.41a.42.42,0,0,0,.42.42H28a.42.42,0,0,0,.43-.42Z",
    style: {
      fill: "#666"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsAuthority, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-authority.481da192.svg";
export { ForwardRef as ReactComponent };